import http from "../http-common";

class OriginDataService {
    getAll(params = {}) {
        return http.get('/origins', { params });
    }

    getActive(params = {}) {
        return http.get('/origins', { params: { ...params, active_only: true } });
    }

    get(id) {
        return http.get(`/origins/${id}`);
    }

    create(data) {
        return http.post('/origins', data);
    }

    update(id, data) {
        return http.put(`/origins/${id}`, data);
    }

    delete(id) {
        return http.delete(`/origins/${id}`);
    }
}

export default new OriginDataService();
